document.addEventListener("DOMContentLoaded", () => {
  function insertSubscriptionBenefits() {
    const subscriptionBenefitEl = document.querySelector('.js-subscription-benefits')
    const rechargeEl = document.querySelector('.rc-selling-plans')
    if (!rechargeEl) return
    const benefitsInsertEl = rechargeEl.querySelector('.subscription-benefits--inserted')

    if (!benefitsInsertEl) {
      const clone = subscriptionBenefitEl.cloneNode(true)
      clone.classList.add('subscription-benefits--inserted')
      clone.style.display = ''
      rechargeEl.insertAdjacentElement('beforeend', clone)
    }
  }

  const observer = new MutationObserver(() => {
    const rechargeEl = document.querySelector('.rc-selling-plans')
    if (rechargeEl) insertSubscriptionBenefits()
    splitRechargeLabel()
  })

  observer.observe(document.body, { childList: true, subtree: true })

  insertSubscriptionBenefits()

  function splitRechargeLabel() {
    const onetimeRadioEl = document.querySelector('.onetime-radio')
    
    if (!onetimeRadioEl) return
    
    const label = onetimeRadioEl.querySelector('.rc-radio__label')

    if (label.querySelector('.rc-radio__label-wrapper')) return

    const text = label.textContent.trim()
    if (!text) return

    const [title, price] = text.split('$')

    const wrapper = document.createElement('div')
    wrapper.classList.add('rc-radio__label-wrapper')

    const spanText = document.createElement('span')
    spanText.classList.add('rc-radio__label--text')
    spanText.textContent = title.trim()

    const spanPrice = document.createElement('span')
    spanPrice.classList.add('rc-radio__label--price')
    if (price) spanPrice.textContent = `$${price.trim()}`

    wrapper.appendChild(spanText)
    if (price) wrapper.appendChild(spanPrice)

    label.textContent = ''
    label.appendChild(wrapper)
  }

  splitRechargeLabel()
})
